module.exports = __webpack_public_path__ + "static/media/logoWhite.04b5aa56.svg";